import React from "react";

const RefundPolicy = () => {
    return (
        <div className="max-w-3xl mx-auto px-4 py-10 text-gray-800">
            <h1 className="text-4xl sm:text-5xl font-extrabold mb-8 text-center text-gray-800 underline decoration-indigo-500">
                Refund Policy
            </h1>
            <p className="mb-4 font-semibold">Effective Date: 27th June 2025</p>
            <p className="mb-6">
                At TACTOS Strategic Solutions LLP, we aim to provide clear and transparent policies regarding refunds for all our users and participants.
            </p>

            <section className="mb-8">
                <h2 className="text-xl font-semibold mb-2">Non-Refundable Services</h2>
                <ul className="list-disc list-inside space-y-2">
                    <li>Startup registration fees are non-refundable under all circumstances.</li>
                    <li>Matrimony registration fees are non-refundable.</li>
                    <li>Event fees are non-refundable in cases where the attendee fails to attend the event.</li>
                </ul>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold mb-2">Refundable Scenarios</h2>
                <ul className="list-disc list-inside space-y-2">
                    <li>If an event is cancelled by TACTOS, a full refund will be issued.</li>
                    <li>If an event is cancelled due to natural causes (e.g., weather conditions, emergencies), a full refund will be issued.</li>
                </ul>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold mb-2">Processing Time</h2>
                <ul className="list-disc list-inside space-y-2">
                    <li>Refunds, where applicable, will be processed and credited within 7 business days from the date of confirmation.</li>
                    <li>Refunds will be initiated to the same bank account or payment method used during the original transaction.</li>
                </ul>
            </section>

            <section className="mb-8">
                <p>
                    If you have any questions regarding this policy, please contact us at{" "}
                    <a
                        href="mailto:tactosinfo@gmail.com"
                        className="text-blue-600 hover:underline"
                    >
                        tactosinfo@gmail.com
                    </a>
                </p>
            </section>
        </div>
    );
};

export default RefundPolicy;
